module.exports = __webpack_public_path__ + "img/about-us.9148b2b5.jpg";